import UFOSegment from "@atlaskit/react-ufo/segment";

import { GlobalFooter } from "@/patterns/global-footer/src";
import GlobalNavigaton from "@/patterns/global-nav/src";
import { SearchTemplate } from "@/templates/search/search-page/src/search-template";

export const SearchResultsPage = () => {
    return (
        <UFOSegment name="search-page">
            <GlobalNavigaton
                isShowTryNowLink={true}
                isShowSearchButton={false}
                productKey="search"
            />
            <SearchTemplate />
            <GlobalFooter />
        </UFOSegment>
    );
};
